/**
 * @type {Object}
 * @description
 */
export const $userEditions = [
  {
    value: 'education',
    label: 'Education',
    description:
      'Contains features tailored for education institutions and course providers',
  },
  {
    value: 'community',
    label: 'Community',
    description:
      'Contains features tailored for local government and charities',
  },
  {
    value: 'business',
    label: 'Standard',
    description: 'Standard edition - Default',
  },
]

/**
 * @type {Object}
 * @description
 */
export const $accountType = [
  {
    value: 'internal',
    label: 'Internal',
    description: 'Is an Internal Account',
  },
  {
    value: 'client',
    label: 'Client',
    description: 'Is a Client Account',
  },
]

/**
 * @type {Object}
 * @description
 */
export const $planType = [
  {
    value: 'platypus',
    label: 'Legacy',
    description: 'Legacy access to the system',
  },
  {
    value: 'armadillo',
    label: 'Natives Campaigns',
    description: 'Natives clients',
  },
  {
    value: 'koala',
    label: 'Essentials',
    description: 'Execution platform',
  },
  {
    value: 'alpaca',
    label: 'Enterprise',
    description: 'Execution platform',
  },
  {
    value: 'lemur',
    label: 'Internal',
    description: 'Internal Accounts',
  },
]

/**
 * @type {Object}
 * @description
 */
export const $accountDefaults = {
  capture: {
    label: 'Events',
    description: 'Offline lead capture and event attendee management',
    accountPath: 'plan.capture.enabled',
    category: 'conversion',
  },
  popoutWizard: {
    label: 'Popout Forms',
    description: 'Snippet generator for the popout forms',
    accountPath: 'features.popoutWizard.enabled',
    category: 'conversion',
  },
  trackingWizard: {
    label: 'Tracking URLs',
    description: 'Tracking URL builder for generating URLs',
    accountPath: 'features.trackingWizard.enabled',
    category: 'conversion',
  },
  csvImport: {
    label: 'CSV Import',
    description: 'Import leads from CSV files',
    accountPath: 'features.csvImport.enabled',
    category: 'conversion',
  },
  forms: {
    label: 'Forms',
    description:
      'Lead capture forms that can be embedded on individual web pages or across entire websites',
    accountPath: 'plan.embeds.enabled',
    category: 'enrolment',
    hidden: true,
  },
  sms: {
    label: 'SMS',
    description:
      'Ability to send direct and auto-response SMS messages to leads',
    accountPath: 'plan.allowSMSMsg',
    category: 'conversion',
  },
  advanced: {
    label: 'Advanced Settings',
    description:
      'Advanced agency settings, such as conversion and remarketing tags',
    accountPath: 'plan.advancedSettings',
    category: 'conversion',
  },
  automation: {
    label: 'Autoresponders',
    description: 'Auto-response email automation, sent on lead submission',
    accountPath: 'plan.automation',
    category: 'conversion',
  },
  advancedContactAutomation: {
    label: 'Advanced Contact Automation',
    description: 'Advanced create contact, update contact',
    accountPath: 'features.advancedContactAutomation.enabled',
    category: 'enrolment',
  },
  advancedOpportunityAutomation: {
    label: 'Advanced Opportunity Automation',
    description: 'Advanced create opportunity, update opportunity',
    accountPath: 'features.advancedOpportunityAutomation.enabled',
    category: 'enrolment',
  },
  analytics: {
    label: 'Analytics',
    description: 'Visitor and lead analytics for campaigns',
    accountPath: 'features.analytics.enabled',
    category: 'insight',
  },
  zapier: {
    label: 'Zapier Integrations',
    description: 'Integrations with 400+ external platforms using Zapier',
    accountPath: 'features.zapier.enabled',
    category: 'integrations',
  },
  directIntegrations: {
    label: 'Direct Integrations',
    description: 'Integrate directly with popular external platforms',
    accountPath: 'features.directIntegrations.enabled',
    category: 'integrations',
  },
  urlBuilder: {
    label: 'URL Builder',
    description:
      'Helper for adding parameters to URLs for use in custom web-based or email ad campaigns',
    accountPath: 'features.urlBuilder.enabled',
    category: 'conversion',
    userGroups: 'developer',
  },
  marketingAutomation: {
    label: 'Automation',
    description: 'Automation workflows and email/SMS responses',
    accountPath: 'features.marketingAutomation.enabled',
    category: 'enrolment',
  },
  hobsons: {
    label: 'Hobsons CRM Integration',
    description: 'Integrations with Hobsons',
    accountPath: 'features.hobsons.enabled',
    category: 'integrations',
    userGroups: 'developer',
  },
  automationR2: {
    label: 'Advanced Automation',
    description: 'Advanced features for automation',
    accountPath: 'features.automationR2.enabled',
    category: 'enrolment',
    disableAgencyOnly: true,
  },
  reports: {
    label: 'Reports',
    description: 'View and share reports',
    accountPath: 'features.reports.enabled',
    category: 'conversion',
  },
  dashboards: {
    label: 'Dashboards',
    description: 'Publish dashboards and generate reports',
    accountPath: 'features.dashboards.enabled',
    category: 'insight',
  },
  campaignsDashboards: {
    label: 'Campaign Dashboards',
    description: 'Cerebro powered campaign/platform dashboards',
    accountPath: 'features.campaignsDashboards.enabled',
    category: 'advertising',
  },
  studentNetworkDashboards: {
    label: 'Student MarketPlace Dashboard',
    description:
      'View Student MarketPlace performance in the Advertising Performance Dashboards',
    accountPath: 'features.studentNetworkDashboards.enabled',
    category: 'advertising',
  },
  dataLabsDashboards: {
    label: 'Data Labs Dashboards',
    description: 'Cerebro powered Data Labs dashboards',
    accountPath: 'features.dataLabsDashboards.enabled',
    category: 'insight',
  },
  funnelReporting: {
    label: 'Enrolment Attribution [v1]',
    description: 'Report on the success of your recruitment',
    accountPath: 'features.funnelReporting.enabled',
    category: 'enrolment',
  },
  enrolmentAttributionV2: {
    label: 'Enrolment Attribution [v2]',
    description: 'Report on the success of your recruitment',
    accountPath: 'features.enrolmentAttributionV2.enabled',
    category: 'enrolment',
  },
  marketPenetration: {
    label: 'Market Penetration',
    description: 'Report on market penetration by local authority or country',
    accountPath: 'features.marketPenetration.enabled',
    category: 'insight',
  },
  companies: {
    label: 'Companies',
    description: 'Allows the creation of companies to store leads within',
    accountPath: 'features.companies.enabled',
    category: 'enrolment',
  },
  contacts: {
    label: 'Contacts',
    description: 'Allows the creation of contacts',
    accountPath: 'features.contacts.enabled',
    category: 'conversion',
  },
  opportunities: {
    label: 'Opportunities',
    description: 'Allows the creation of opportunities',
    accountPath: 'features.opportunities.enabled',
    category: 'enrolment',
  },
  googleSheetsIntegrations: {
    label: 'Google Sheets Integrations',
    description: 'Integrate with Google Sheets',
    accountPath: 'features.googleSheetsIntegrations.enabled',
    category: 'integrations',
  },
  htmlForms: {
    label: 'External HTML Forms',
    description: 'External HTML form embeds',
    accountPath: 'features.htmlForms.enabled',
    category: 'addons',
    hidden: true,
  },
  htmlFormsTracking: {
    label: 'Form Abandonment',
    description: 'Tracks partial completion in forms (Partials/Bottlenecks)',
    accountPath: 'features.htmlFormsTracking.enabled',
    category: 'conversion',
  },
  externalFormAbandonment: {
    label: 'External Form Abandonment',
    description:
      'Tracks partial completion in external forms (Partials/Bottlenecks)',
    accountPath: 'features.externalFormAbandonment.enabled',
    category: 'conversion',
  },
  contactActivityJson: {
    label: 'Single contact export',
    description: 'Single contact export with a simplified activity feed',
    accountPath: 'features.contactActivityJson.enabled',
    category: 'conversion',
    userGroups: 'developer',
  },
  akeroMailer: {
    label: 'Akero Mailer',
    description: 'Utilise Akero Mailer webhooks for contacts',
    accountPath: 'features.akeroMailer.enabled',
    category: 'integrations',
  },
  abTesting: {
    label: 'A/B testing',
    description:
      'Compare two or more versions of a landing page/form against each other to determine which one performs better',
    accountPath: 'features.abTesting.enabled',
    category: 'conversion',
  },
  containers: {
    label: 'Page Manager Containers',
    description:
      'Split traffic to different landing pages/forms based on a query parameter',
    accountPath: 'features.containers.enabled',
    category: 'conversion',
  },
  webhooks: {
    label: 'Webhooks',
    description: 'Send entity data to a generic endpoint',
    accountPath: 'features.webhooks.enabled',
    category: 'integrations',
  },
  sftp: {
    label: 'SFTP',
    description: 'Send entity data to an SFTP server',
    accountPath: 'features.sftp.enabled',
    category: 'integrations',
  },
  facebookLeadAds: {
    label: 'Facebook Lead Ads',
    description: 'Receive entity data from Facebook',
    accountPath: 'features.facebookLeadAds.enabled',
    category: 'integrations',
  },
  box: {
    label: 'Box Integration',
    description: 'Store entity data in Box folders',
    accountPath: 'features.box.enabled',
    category: 'integrations',
  },
  clickTracking: {
    label: 'Click Tracking',
    description: 'Track clicks for URLs built with the Tracking URL builder',
    accountPath: 'features.clickTracking.enabled',
    category: 'conversion',
  },
  charms: {
    label: 'CHARMS Integration',
    description: 'Integrate with CHARMS',
    accountPath: 'features.charms.enabled',
    category: 'integrations',
  },
  consent: {
    label: 'Consent Fields',
    description: 'Gather consent from leads/contacts',
    accountPath: 'features.consent.enabled',
    category: 'conversion',
  },
  contactQueryBuilder: {
    label: 'Contact Segment Builder',
    description: 'Segment your contact data',
    accountPath: 'features.contactQueryBuilder.enabled',
    category: 'conversion',
  },
  leadQueryBuilder: {
    label: 'Lead Segment Builder',
    description: 'Segment your lead data',
    accountPath: 'features.leadQueryBuilder.enabled',
    category: 'conversion',
  },
  // socialPerformance: {
  //   label: "Engagement Metrics",
  //   description: "View how your social posts are engaged with",
  //   accountPath: "features.socialPerformance.enabled",
  //   category: "insight",
  // },
  akeroAdvertising: {
    label: 'Advertising',
    description: 'Create campaign briefs and quotes',
    accountPath: 'features.akeroAdvertising.enabled',
    category: 'advertising',
  },
  surveys: {
    label: 'Survey tool',
    description: 'Create and manage surveys',
    accountPath: 'features.surveys.enabled',
    category: 'conversion',
  },
  agencyAssets: {
    label: 'Legacy Asset Forms',
    description: 'Collect assets from your clients',
    accountPath: 'features.agencyAssets.enabled',
    category: 'advertising',
  },
  calendar: {
    label: 'Account Calendar',
    description: 'Manage your calendar events on your account',
    accountPath: 'features.calendar.enabled',
    category: 'enrolment',
  },
  calendarAgency: {
    label: 'Agency Calendar',
    description:
      'Manage your calendar events across the accounts in your agency',
    accountPath: 'features.calendarAgency.enabled',
    category: 'conversion',
    hideFor: {
      account: true,
    },
  },
  slate: {
    label: 'File Upload Integration',
    description: 'Integration with various platforms such as Slate',
    accountPath: 'features.slate.enabled',
    category: 'integrations',
  },
}
